import { articleUrls } from "@clockwise/client-commons/src/constants/help-center";
import { schedulingLinkAsanaFeedbackUrl } from "@clockwise/client-commons/src/constants/site";
import { OneOnOneAutopilotPage } from "@components/one-on-one-autopilot/OneOnOneAutopilot";
import SchedulingLinkDashboard from "@components/scheduling-link-dashboard/SchedulingLinkDashboard";
import { TopNavigation } from "@components/TopNavigation";
import React from "react";
import ClockwiseHomeSidebar from "./ClockwiseHomeSidebar";
import ThreePieceLayout from "@clockwise/web-commons/src/ui/layouts/ThreePieceLayout";
import { SettingsDialog } from "@components/settings-dialog";
import { getCurrentEnvironment } from "@src/state/relay-environment";
import { useDispatch, useSelector } from "react-redux";
import { setSettingsDialogOpen } from "@actions/chrome-extension.actions";
import { IReduxState } from "@reducers/root.reducer";

export type AppNavPageView = "one-on-ones" | "scheduling-links";
export type AppNavModal = "settings" | null; // null is accepted here because modal isn't always open
export type AllAppNavViews = AppNavPageView | AppNavModal;

const TopNavWithFeedbackUrl = (feedbackUrl: string) => {
  return (
    <div className="cw-w-full">
      <TopNavigation pageTitle="" feedbackUrl={feedbackUrl} showCalendarButton />
    </div>
  );
};

export const ClockwiseHome = (pageView: AppNavPageView) => (props: any) => {
  const dispatch = useDispatch();
  const [currentPageView, setCurrentView] = React.useState<AppNavPageView>(pageView);
  const settingsDialogOpen = useSelector(
    (state: IReduxState) => state.webExtension.settingsDialogOpen,
  );

  const getPathForView = (view: AppNavPageView) => {
    switch (view) {
      case "one-on-ones":
        return "one-on-ones";
      case "scheduling-links":
        return "scheduling-links";
      default:
        return "";
    }
  };

  const toggleSettingsModal = () => {
    if (!settingsDialogOpen) {
      dispatch(setSettingsDialogOpen(true));
    } else {
      dispatch(setSettingsDialogOpen(false));
    }
  };

  const updateCurrentPageView = (selectedView: AppNavPageView) => {
    const path = getPathForView(selectedView);
    window.history.pushState("", "", `${path ? `/app/${path}` : ``}`); // set url

    setCurrentView(selectedView);
  };

  const updateCurrentView = (selectedView: AllAppNavViews) => {
    if (selectedView == "settings" || selectedView == null) {
      // Handle Modal views here
      toggleSettingsModal();
    } else {
      // Handle Page view
      updateCurrentPageView(selectedView);
    }
  };

  let PageView, feedbackUrl, TopNav;

  switch (currentPageView) {
    case "scheduling-links":
      PageView = SchedulingLinkDashboard;
      feedbackUrl = schedulingLinkAsanaFeedbackUrl;
      TopNav = TopNavWithFeedbackUrl(feedbackUrl);
      break;
    case "one-on-ones":
      PageView = OneOnOneAutopilotPage;
      feedbackUrl = articleUrls.feedback;
      TopNav = TopNavWithFeedbackUrl(feedbackUrl);
      break;
  }

  return (
    <div>
      <ThreePieceLayout
        topNav={TopNav}
        pageView={
          <div className="cw-w-full cw-flex cw-justify-center">
            <PageView {...props} />
          </div>
        }
        sidebar={
          <ClockwiseHomeSidebar
            currentModalView={settingsDialogOpen ? "settings" : null}
            currentPageView={currentPageView}
            onSelectView={updateCurrentView}
          />
        }
      />
      {settingsDialogOpen && (
        <SettingsDialog
          environment={getCurrentEnvironment()}
          onClose={() => {
            toggleSettingsModal();
          }}
        />
      )}
    </div>
  );
};
